<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { LPopup } from 'vue2-leaflet';
import MapMixin from '@/Mixins/115/MapMixin';
export default {
  name: 'addressPopup',
  mixins: [MapMixin],
  components: { LPopup },
  props: {
    latLng: {
      type: Object,
      required: true,
      default: () => ({ lat: null, lng: null }),
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {},
  methods: {
    computedOffset: function () {
      const popup = this.$refs.addressPopup?.mapObject;
      popup.options.offset = [0, -5];
      popup?.update();
    },
  },
  watch: {
    isLoading: {
      handler() {
        this.$nextTick(() => {
          this.computedOffset();
        });
      },
      immediate: true,
      deep: true,
    },
    latLng: {
      async handler(currentVal) {
        if (currentVal.lat && currentVal.lng) {
          this.isLoading = true;
          await this.getMapReverseGeoCode(currentVal);
          this.isLoading = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<template>
  <l-popup ref="addressPopup" :offset="computedOffset">
    <div class="bg-white">
      <div class="mb-1">
        <div
          class="fontFamilySET mx-auto text-center rounded"
          :class="['caption', isLoading ? 'grey lighten-3 animate-pulse grey--text lighten-3' : '']"
          :style="{
            width: 'fit-content',
            minWidth: '80px',
            minHeight: '16px',
          }"
          style="font-family: Yekan-Bakh-Regular !important"
        >
          {{ address || 'آدرسی یافت نشد' }}
        </div>
      </div>
      <slot name="action" :address="address"></slot>
      <!-- <div class="mt-2">
        <div
          class="fontFamilySET mx-auto text-center rounded"
          :class="['caption', isLoading ? 'grey lighten-3 animate-pulse grey--text lighten-3' : '']"
          :style="{
            width: 'fit-content',
            minWidth: '80px',
            minHeight: '16px'
          }"
          style="font-family: Yekan-Bakh-Regular !important"
        >
          موقعیت جغرافیایی : &nbsp; &nbsp; lat : {{ latLng?.lat?.toFixed(3) || '' }} &nbsp; - &nbsp;
          lng : {{ latLng?.lng?.toFixed(3) || '' }}
        </div>
      </div> -->
    </div>
  </l-popup>
</template>
<style scoped>
/* انیمیشن pulse برای Vuetify 2 */
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
